import React from 'react';
import DayCard from './day-card'
import Carousel from 'react-multi-carousel';
import httpRequest from './request-api'
class Weather extends React.Component {
    state = {
        fullData: [],
        dailyData: [],
    }

    async getWeather() {
        const province = this.props.province

        await httpRequest.weather(province).then(result => {
            const dailyData = result.data.list.filter(reading => reading.dt_txt.includes("12:00:00"))

            this.setState({
                fullData: result.data.list,
                dailyData: dailyData,
            })
        }).catch(error => {
            console.log(error);
        })
    }

    componentDidMount = async () => {
        await this.getWeather()
    }

    formatDayCards = () => {
        return this.state.dailyData.map((reading, index) => <div key={index}><DayCard reading={reading} key={index} /></div> )
    }

    render() {
        const responsive = {
            superLargeDesktop: {
                // the naming can be any, depends on you.
                breakpoint: { max: 4000, min: 3000 },
                items: 5
            },
            desktop: {
                breakpoint: { max: 3000, min: 1024 },
                items: 5
            },
            tablet: {
                breakpoint: { max: 1024, min: 464 },
                items: 3
            },
            mobile: {
                breakpoint: { max: 464, min: 0 },
                items: 1
            }
        };
      
        return (
            <Carousel responsive={responsive}>
                {this.formatDayCards()}
            </Carousel>
        )
    }
}

export default Weather;